import { type ImgHTMLAttributes, forwardRef } from "react";

import { clsx } from "clsx";

type T = HTMLImageElement;
type P = ImgHTMLAttributes<T> & {
  selected?: boolean;
  // "sheet": a page in the records review, lifted off the pane; selected, it
  // wears the active letter card's teal ring.
  variant?: "thumbnail" | "sheet";
};

const SHEET =
  "shadow-[0_0_0_1px_rgba(15,23,42,.06),0_10px_30px_rgba(15,23,42,.08)]";
const SHEET_SELECTED =
  "shadow-[0_0_0_1.5px_#127772,0_0_0_6px_rgba(23,150,148,.14),0_14px_32px_-12px_rgba(23,150,148,.45)]";

// Lazy by default: file links change every few hours, so a long page list
// would otherwise refetch every image at once.
export const Figure = forwardRef<T, P>(
  ({ selected, variant = "thumbnail", className, ...props }, ref) => (
    <figure>
      <img
        ref={ref}
        loading="lazy"
        decoding="async"
        className={clsx(
          "rounded-md border-none bg-white transition-shadow duration-200 outline-none",
          variant === "sheet" && (selected ? SHEET_SELECTED : SHEET),
          variant === "thumbnail" && selected && "ring-4 ring-indigo-500",
          className,
        )}
        {...props}
      />
    </figure>
  ),
);
